var _rect, _rect2, _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeQuestionWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#C2C2C2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 10,
    fill: "#474747"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 7.5,
    stroke: "#FFC300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.052 15.566C13.052 15.2393 13.1033 14.95 13.206 14.698C13.318 14.446 13.4533 14.222 13.612 14.026C13.78 13.83 13.9573 13.648 14.144 13.48C14.3307 13.312 14.5033 13.1533 14.662 13.004C14.83 12.8453 14.9653 12.682 15.068 12.514C15.18 12.346 15.236 12.1593 15.236 11.954C15.236 11.618 15.096 11.3473 14.816 11.142C14.5453 10.9367 14.1813 10.834 13.724 10.834C13.2853 10.834 12.8933 10.9273 12.548 11.114C12.2027 11.2913 11.918 11.5433 11.694 11.87L10 10.876C10.3733 10.3067 10.8913 9.854 11.554 9.518C12.2167 9.17267 13.0193 9 13.962 9C14.662 9 15.278 9.10267 15.81 9.308C16.342 9.504 16.7573 9.79333 17.056 10.176C17.364 10.5587 17.518 11.03 17.518 11.59C17.518 11.954 17.462 12.276 17.35 12.556C17.238 12.836 17.0933 13.0787 16.916 13.284C16.7387 13.4893 16.5473 13.6807 16.342 13.858C16.146 14.0353 15.9593 14.208 15.782 14.376C15.6047 14.544 15.4553 14.7213 15.334 14.908C15.222 15.0947 15.166 15.314 15.166 15.566H13.052ZM14.116 19.08C13.724 19.08 13.402 18.954 13.15 18.702C12.898 18.45 12.772 18.1513 12.772 17.806C12.772 17.4513 12.898 17.1573 13.15 16.924C13.402 16.6813 13.724 16.56 14.116 16.56C14.5173 16.56 14.8393 16.6813 15.082 16.924C15.334 17.1573 15.46 17.4513 15.46 17.806C15.46 18.1513 15.334 18.45 15.082 18.702C14.8393 18.954 14.5173 19.08 14.116 19.08Z",
    fill: "#FFC300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeQuestionWarning);
export default __webpack_public_path__ + "static/media/Type=QuestionWarning.ce54a4952f93b54950c564ca9d4e32d9.svg";
export { ForwardRef as ReactComponent };